import { actionGenerator, IReduxAction } from '../../utils/actions';

export const JOIN_FAIR_PLAY_INIT = 'FAIR_PLAY :: JOIN_INIT';

export type TJoinFairPlayInitAction = IReduxAction<typeof JOIN_FAIR_PLAY_INIT>;

/**
 * @description Инициализация запроса на заявку участия в акции "Честная игра".
 * Отличие от экшена joinFairPlayStart:
 * joinFairPlayStart сигнализирует о старте запроса на сервер, тогда как joinFairPlayInit триггерит начало всего флоу
 * полуения заявки - вызов саги joinFairPlay. Флоу может закончиться на joinFairPlayInit, если запрос на сервер
 * не нужен, в этом случае joinFairPlayStart не задиспатчится.
 *
 * Флоу следующий:
 * joinFairPlayInit -> joinFairPlayStart -> joinFairPlaySuccess/joinFairPlayFail
 */
export const joinFairPlayInit = actionGenerator<typeof JOIN_FAIR_PLAY_INIT>(JOIN_FAIR_PLAY_INIT);
